<template>
  <main>
    <b-container v-if="visible" class="mb-4 mt-4">
      <b-card
        class="cardStyle"
        title="Please enter your study and site that you want to request access for:"
      >
        <b-form @submit.prevent="validateStudySite">
          <b-form-group id="study" label="Study ID" label-for="study">
            <b-input v-model="study" class="rounded-pill" name="study" required></b-input>
          </b-form-group>
          <b-form-group id="site" label="Site" label-for="site">
            <b-input v-model="site" class="rounded-pill" name="site" required></b-input>
          </b-form-group>

          <div class="mt-4 title text-center">Requested for:</div>
          <access-request-form
            @onFormUpdate="requestForUser = $event"
            @requestType="requestForType = $event"
          />

          <b-button
            :disabled="nextButtonLoading"
            class="mt-2 float-right"
            type="submit"
            variant="primary"
            >OK
            <div v-if="nextButtonLoading" style="display: inline;">
              <b-spinner small></b-spinner>
              <span class="sr-only">Loading...</span>
            </div>
          </b-button>
        </b-form>
      </b-card>
    </b-container>

    <b-container fluid>
      <router-view class="mt-2"></router-view>
    </b-container>
  </main>
</template>

<script>
  import AccessRequestForm from '../../access-requests/custom-request/AccessRequestForm.vue';
  import _ from 'lodash';

  export default {
    name: 'AnonymousFormSelectStudySite',
    components: {
      AccessRequestForm,
    },
    props: { user: Object },
    data() {
      return {
        study: '',
        site: '',
        nextButtonLoading: false,
        token: this.$route.query['token'],
        currentUser: {},
        requestForType: '',
        requestForUser: {},
      };
    },
    computed: {
      visible() {
        return this.$route.name === 'anonymous-form-select-study-site';
      },
    },
    created() {
      if (!this.visible && 'requestType' in this.$route.query) {
        this.$router.replace({
          name: 'anonymous-form-select-study-site',
          query: {
            expires: this.$route.query['expires'],
            token: this.$route.query['token'],
            signature: this.$route.query['signature'],
            requestType: this.requestForType,
          },
        });
      }
      this.initUser();
    },
    methods: {
      initUser() {
        if (this.user === undefined) {
          let vuexUser = this.$store.state.accessRequests.userDetails;
          vuexUser.selectedEmail = vuexUser.email;
          vuexUser.phoneNumber = '';
          this.$store.commit('setUserDetails', vuexUser);
        } else {
          this.user.selectedEmail = this.user.email;
          this.user.phoneNumber = '';
          this.$store.commit('setUserDetails', this.user);
        }
        this.currentUser = _.cloneDeep(this.$store.state.accessRequests.userDetails);
      },
      async validateStudySite() {
        if (Object.keys(this.requestForUser).length === 0) {
          this.errorToast('Please select who are you requesting access for (personal/other user)');
          return;
        }
        if (this.requestForType === 'otherUser') {
          this.$store.commit('setAnonymousUserData', {
            for: this.requestForUser,
            by: this.currentUser,
          });
        } else {
          this.currentUser.phoneNumber = this.requestForUser.phoneNumber;
          this.$store.commit('setAnonymousUserData', {
            for: this.currentUser,
            by: this.currentUser,
          });
        }

        let studySiteExists = false;
        this.nextButtonLoading = true;

        let params = {
          study_id: this.study,
          site_number: this.site,
          token: this.token,
        };
        try {
          // TODO check blocked modules if Application Access Manager .
          let response = await axios.get(`/api/anonymous/get-enrollment-oversight-sites`, {
            params: params,
          });
          if (response.status === 200) {
            studySiteExists = response.data.items.length > 0;
          }
          if (studySiteExists) {
            await this.$router
              .push({
                name: 'anonymous-access-request',
                params: {
                  studyId: this.study,
                  siteId: this.site,
                },
                query: {
                  expires: this.$route.query['expires'],
                  token: this.$route.query['token'],
                  signature: this.$route.query['signature'],
                  requestType: this.requestForType,
                },
              })
              .then(() => {
                this.reset();
              });
          } else {
            this.errorToast(
              'The selected study and site are not valid. ' +
                'Please enter a valid study and site.',
            );
          }
        } catch (e) {
          console.error(e);
          if (e.response.status === 403) {
            this.errorToast('Access Denied - Please refresh or grab a new link from SIP');
          } else {
            this.errorToast(
              'Error occurred while trying to validate study-site. Please try again later or contact support.',
            );
          }
          this.nextButtonLoading = false;
        }

        this.nextButtonLoading = false;
      },
      errorToast(message) {
        this.$bvToast.toast(message, {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      },
      reset() {
        this.study = null;
        this.site = null;
        this.requestForUser = {};
        this.requestForType = null;
      },
    },
  };
</script>
